import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/warehouse-parts`)
  return data.data
}

export const useWarehouseParts = () => {
  const { data, ...props } = useQuery(
    queryKeys.WAREHOUSE_PARTS,
    () => getData(),
  )
  return { data, ...props }
}
